module.exports = __webpack_public_path__ + "static/img/manual_ja_16.503e5a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_16.png
// module id = Wi5d
// module chunks = 4